<template>
    <transition name="fade">
        <button 
            v-show="isVisible" 
            class="scroll-to-top" 
            @click="scrollToTop"
            title="Volver arriba"
        >
            <i class="fas fa-arrow-up"></i>
        </button>
    </transition>
</template>

<script>
export default {
    name: 'ScrollToTop',
    data() {
        return {
            isVisible: false
        };
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            this.isVisible = window.scrollY > 300;
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
};
</script>

<style scoped>
.scroll-to-top {
    position: fixed;
    bottom: 110px;
    right: 30px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #0088CC;
    color: #fff;
    border: none;
    box-shadow: 0 8px 20px rgba(0, 136, 204, 0.3);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    z-index: 997;
    transition: all 0.3s ease;
}

.scroll-to-top:hover {
    background: #006ba3;
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(0, 136, 204, 0.4);
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}

@media (max-width: 576px) {
    .scroll-to-top {
        width: 45px;
        height: 45px;
        bottom: 90px;
        right: 20px;
        font-size: 1.125rem;
    }
}
</style>
